import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FirebaseAuthService {
    user$: Observable<any | null>;
    constructor() {
        this.user$ = new Observable<any | null>((subscriber) => {
            subscriber.next(null);
        });
    }
    async signInWithCustomToken(customToken: string): Promise<void> { return; }
    async getIdToken(): Promise<string | null> { return null; }
    signOut(): Promise<void> { return Promise.resolve(); }
}
